export const FAKES_HEADER_STATISTIC_GROUP_SIZE = 2;

export const NUMERIC_CHANGE_VALUE = 1000;
